import  create  from 'zustand';

const useUserStore = create((set) => ({
  fcmToken: null,
  setFcmToken: (token) => set({ fcmToken: token }),
}));

export default useUserStore;
